import { render } from "./ManageRIskTaskModal.vue?vue&type=template&id=383b5ed2&scoped=true"
import script from "./ManageRIskTaskModal.js?vue&type=script&lang=js"
export * from "./ManageRIskTaskModal.js?vue&type=script&lang=js"

import "./ManageRIskTaskModal.vue?vue&type=style&index=0&id=383b5ed2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383b5ed2"]])

export default __exports__